export const InfoLogs = {
  adyen3dsPaymentSuccess: 'Adyen 3DS payment success',
  addOrChangeCardClicked: 'Add or change card clicked',
  checkoutPresented: 'Checkout presented',
  checkoutPaymentRedirected: 'Checkout payment redirected',
  checkoutPaymentStarted: 'Checkout payment started',
  checkoutPaymentProcessed: 'Checkout payment processed',
  checkoutPaymentSuccess: 'Checkout payment success',
  checkoutPaymentCancelled: 'Checkout payment cancelled',
  checkoutClosed: 'Checkout closed',
};

export const ErrorLogs = {
  adyen3dsPaymentError: 'Adyen 3DS payment error',
  checkoutPaymentError: 'Checkout payment error',
  expressCheckoutError: 'Express checkout error',
  checkoutPaymentMethodNotAvailable: 'Checkout payment method not available',
  nuveiCardFormError: 'Nuvei card form error',
  braintreeCardFormError: 'Braintree card form error',
  adyenCardFormError: 'Adyen card form error',
  appchargePaymentElementCardFormError: 'Appcharge payment element card form error',
};
